export const areas = [
  // Sector 1: New Cairo & East Cairo (10)
  "التجمع الأول",
  "التجمع الخامس",
  "التجمع الثالث",
  "مدينة نصر",
  "مصر الجديدة",
  "القطامية",
  "الحرفيين",
  "مدينة السلام",
  "جسر السويس",
  "التجمع الخامس مدينة نصر",

  // Sector 2: South Cairo, Maadi & Nile (7)
  "المعادي",
  "زهراء المعادي",
  "صقر قريش",
  "حلوان",
  "المقطم",
  "المنيل",
  "السيدة عائشة",

  // Sector 3: Giza Core & Central (7)
  "الجيزة",
  "المهندسين",
  "الدقي",
  "العجوزة",
  "إمبابة",
  "الوراق",
  "المنيب",

  // Sector 4: West Giza & New Cities (5)
  "الهرم",
  "فيصل",
  "6 أكتوبر",
  "حدائق الأهرام",
  "الشيخ زايد",

  // Sector 5: North Cairo & Qalyubia (3)
  "شبرا",
  "شبرا الخيمة",
  "المطرية",

  // Sector 6: Highways & Central Axes (3)
  "الطريق الدائري",
  "الأوتوستراد",
  "صلاح سالم",

  // Sector 7: Canal Road & Sharqia / Delta (2)
  "التل الكبير",
  "أبو حماد"
];

export const regionsByGovernorate = [
  {
    name: "القاهرة الجديدة وشرق القاهرة",
    areas: [
      "التجمع الأول",
      "التجمع الخامس",
      "التجمع الثالث",
      "مدينة نصر",
      "مصر الجديدة",
      "القطامية",
      "الحرفيين",
      "مدينة السلام",
      "جسر السويس",
      "التجمع الخامس مدينة نصر"
    ]
  },
  {
    name: "جنوب القاهرة وحلوان والمعادي",
    areas: [
      "المعادي",
      "زهراء المعادي",
      "صقر قريش",
      "حلوان",
      "المقطم",
      "المنيل",
      "السيدة عائشة"
    ]
  },
  {
    name: "وسط الجيزة والدقي والمهندسين",
    areas: [
      "الجيزة",
      "المهندسين",
      "الدقي",
      "العجوزة",
      "إمبابة",
      "الوراق",
      "المنيب"
    ]
  },
  {
    name: "غرب الجيزة وأكتوبر وزايد",
    areas: [
      "الهرم",
      "فيصل",
      "6 أكتوبر",
      "حدائق الأهرام",
      "الشيخ زايد"
    ]
  },
  {
    name: "شمال القاهرة وشبرا",
    areas: [
      "شبرا",
      "شبرا الخيمة",
      "المطرية"
    ]
  },
  {
    name: "المحاور والطرق السريعة",
    areas: [
      "الطريق الدائري",
      "الأوتوستراد",
      "صلاح سالم"
    ]
  },
  {
    name: "طريق القناة ومحافظة الشرقية والإسماعيلية",
    areas: [
      "التل الكبير",
      "أبو حماد"
    ]
  }
];
